export const isACast = (link: string) => {
    return link.indexOf('https://play.acast.com/s/') >= 0
}

export const getEmbedOptions = (
    link: string,
    theme = 'light',
): {
    src: string
    height: number
} => {
    // strip out the /s/ from play.acast.com urls, as it is not required as a path on embed.acast.com
    const processedLink = link.replace('https://play.acast.com/s/', '')

    // If it contains a / at this point it must have a guid, indicating it should be a single player
    // e.g the-lady-vanishes/cb8c056f-4328-4ceb-83b9-cd35a222708d as opposed too the-lady-vanishes
    if (processedLink.indexOf('/') !== -1) {
        return {
            src: `https://embed.acast.com/${processedLink}?theme=${theme}`,
            height: 188,
        }
    }
    return {
        src: `https://embed.acast.com/${processedLink}?feed=true&theme=${theme}`,
        height: 375,
    }
}
